import { makeStyles } from "@mui/styles";
import { default_label_colors } from "utils/constants";

const useStyles = makeStyles((theme: any) => ({
  align_center: {
    display: "flex",
    alignItems: "center",
  },

  align_end: {
    display: "flex",
    alignItems: "flex-end",
  },

  justify_center: {
    display: "flex",
    justifyContent: "center",
  },

  justify_end: {
    display: "flex",
    justifyContent: "flex-end",
  },

  direction_row: {
    flexDirection: "row",
  },

  direction_column: {
    flexDirection: "column",
  },

  display_flex_baseline: {
    display: "flex",
    alignItems: "baseline",
  },

  breadcrumb_container: {
    position: "sticky",
    top: 48,
    zIndex:999,
    padding: "10px 40px",
    background: theme.palette.dominos.dominos_red,
    boxShadow:
      "0px 2px 4px -1px #00000033, 0px 4px 5px 0px #00000024, 0px 1px 10px 0px #0000001f",
    marginBottom: 10,
  },

  breadcrumb_head: {
    color: "#ffffff" || theme.palette.dominos.white,
    fontFamily: "BebasNeue-Bold",
    fontSize: 30,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textTransform: "uppercase",
  },

  breadcrumb_time: {
    fontFamily: "BebasNeue-Bold",
    color: theme.palette.dominos.white,
    fontSize: 24,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
  },

  breadcrumb_description: {
    fontFamily: "BebasNeue-Bold",
    color: theme.palette.dominos.white,
    fontSize: 24,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
  },

  main_layout_padding: {
    padding: "20px 20px 50px 20px",
  },

  colored_input_feild: {
    fontSize: 16,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: theme.palette.dominos.dominos_blue,
    background: "#fff",
  },

  input_feild: {
    fontSize: 16,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    background: "#fff",
    color: theme.palette.dominos.black,
  },

  input_feild_2: {
    fontSize: 24,
    fontWeight: 900,
    lineHeight: "normal",
    letterSpacing: "normal",
    background: "#fff",
    color: theme.palette.dominos.black,
  },

  info_table: {
    fontSize: 18,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: theme.palette.primary.color_f,
  },

  background_blue: {
    background: theme.palette.dominos.dominos_blue,
  },

  background_light_gray: {
    background: "#e0e0e0",
  },

  table_head: {
    fontSize: 22,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: 1,
    color: theme.palette.dominos.dominos_white,
    fontFamily: "BebasNeue-Bold",
    textTransform: "uppercase",
    background: theme.palette.dominos.dominos_blue,
  },

  table_body: {
    fontSize: 18,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: 1,
    fontFamily: "BebasNeue-Bold",
    textTransform: "uppercase",
  },

  normal_text: {
    fontSize: 16,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: theme.palette.dominos.black,
  },

  simple_normal_text: {
    fontSize: 15,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: theme.palette.dominos.black,
  },

  pagination_per_page: {
    padding: 5,
    borderRadius: 4,
    fontSize: 14,
    color: theme.palette.dominos.dominos_blue,
    background: theme.palette.dominos.dominos_white,
    marginRight: 30,
  },

  color_secondary: {
    color: `${theme.palette.dominos.dominos_blue} !important`,
  },

  color_primary: {
    color: `${theme.palette.dominos.dominos_dark_blue} !important`,
  },

  bg_gray: {
    backgroundColor: "#f6f6f6",
    background: "#f6f6f6",
  },

  primary_divider: {
    borderColor: theme.palette.dominos.dominos_dark_blue,
    borderBottomWidth: "medium",
  },

  secondary_divider: {
    borderColor: theme.palette.dominos.dominos_blue,
    borderBottomWidth: "medium",
  },

  gray_divider: {
    borderColor: theme.palette.dominos.grey1,
    borderBottomWidth: "medium",
    borderLeftWidth: "medium",
    borderRadius: 10,
  },

  pagination_container: {
    color: theme.palette.dominos.dominos_blue,
    "& ul": {
      "& li": {
        "& .Mui-selected": {
          background: theme.palette.dominos.dominos_blue,
          border: `1px solid ${theme.palette.dominos.dominos_blue}`,
          color: theme.palette.dominos.dominos_white,
          fontFamily: "Roboto-Regular",
          fontSize: 14,
          borderRadius: 3,
          "&:hover": {
            background: theme.palette.dominos.dominos_blue,
            color: theme.palette.dominos.dominos_white,
          },
        },
        "& button": {
          background: theme.palette.dominos.dominos_white,
          color: theme.palette.dominos.dominos_blue,
        },
      },
    },
  },

  check_icon: {
    color: `${theme.palette.dominos.dominos_blue} !important`,
    height: 24,
    width: 24,
  },

  selected_row: {
    border: `2px solid ${theme.palette.dominos.dominos_blue}`,
  },

  unselected_row: {
    borderBottom: `none`,
    borderTop: `2px solid transparent`,
    borderLeft: `2px solid transparent`,
    borderRight: `2px solid transparent`,
  },

  input_label_style: {
    padding: "0px 0px 4px 10px",
    fontFamily: "BebasNeue-Book",
    fontSize: 16,
    fontWeight: 900,
    lineHeight: "normal",
    letterSpacing: "1px",
    color: theme.palette.dominos.black,
    textTransform: "uppercase",
  },

  typography_heading_style: {
    padding: "0px 0px 4px 10px",
    fontFamily: "BebasNeue-Bold",
    fontSize: 22,
    fontWeight: 900,
    lineHeight: "normal",
    letterSpacing: "1px",
    color: theme.palette.dominos.black,
    textTransform: "uppercase",
  },

  typography_otp_heading_style: {
    padding: "0px 0px 4px 10px",
    fontFamily: "BebasNeue-Bold",
    fontSize: 20,
    fontWeight: 900,
    lineHeight: "normal",
    letterSpacing: "1px",
    color: "#fff",
    textTransform: "uppercase",
  },

  white_input_label_style: {
    padding: "0px 0px 4px 10px",
    fontFamily: "BebasNeue-Book",
    fontSize: 16,
    fontWeight: 900,
    lineHeight: "normal",
    letterSpacing: "1px",
    color: theme.palette.dominos.dominos_white,
    textTransform: "uppercase",
  },

  color_red: {
    color: `red !important`,
  },

  button_width: {
    minWidth: 120,
    maxHeight: 43,
    minHeight: 43,
    textTransform: "none",
    boxShadow: "none",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "none",
      minWidth: "0px",
      marginBottom: 5,
    },
  },

  green_contained_button: {
    background: "green",
    borderColor: "green",
    color: theme.palette.dominos.dominos_white,
    transition: "0.2s",
    fontFamily: "BebasNeue-Bold",
    fontSize: 18,
    "&:hover": {
      background: "green",
      borderColor: "green",
      color: theme.palette.dominos.dominos_white,
      transition: "0.2s",
      boxShadow:
        "4px 4px 3px -1px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
    },
  },

  red_contained_button: {
    background: theme.palette.dominos.dominos_red,
    borderColor: theme.palette.dominos.dominos_red,
    color: theme.palette.dominos.dominos_white,
    transition: "0.2s",
    fontFamily: "BebasNeue-Bold",
    fontSize: 18,
    "&:hover": {
      background: theme.palette.dominos.dominos_red,
      borderColor: theme.palette.dominos.dominos_red,
      color: theme.palette.dominos.dominos_white,
      transition: "0.2s",
      boxShadow:
        "4px 4px 3px -1px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
    },
  },

  contained_button: {
    background: theme.palette.dominos.dominos_blue,
    color: theme.palette.dominos.dominos_white,
    transition: "0.2s",
    fontFamily: "BebasNeue-Bold",
    fontSize: 18,
    textTransform: "uppercase",
    "&:hover": {
      background: theme.palette.dominos.dominos_blue,
      color: theme.palette.dominos.dominos_white,
      transition: "0.2s",
      boxShadow:
        "4px 4px 3px -1px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
    },
  },

  numpad_button: {
    color: "#ffffff",
    fontSize: 25,
    background: "#0078ac",
    transition: "0.2s",
    fontFamily: "BebasNeue-Bold",
    textTransform: "uppercase",
    "&:hover": {
      color: "#ffffff",
      fontSize: 25,
      background: "#0078ac",
    },
  },

  red_numpad_button: {
    color: "#ffffff",
    fontSize: 25,
    background: "#d2112b",
    borderColor: "#d2112b",
    transition: "0.2s",
    fontFamily: "BebasNeue-Bold",
    textTransform: "uppercase",
    "&:hover": {
      color: "#ffffff",
      fontSize: 25,
      background: "#d2112b",
      borderColor: "#d2112b",
    },
  },

  green_numpad_button: {
    color: "#ffffff",
    fontSize: 25,
    background: "green",
    borderColor: "green",
    transition: "0.2s",
    fontFamily: "BebasNeue-Bold",
    textTransform: "uppercase",
    "&:hover": {
      color: "#ffffff",
      fontSize: 25,
      background: "green",
      borderColor: "green",
    },
  },

  check_in_button: {
    color: "#ffffff",
    fontSize: 25,
    background: theme.palette.dominos.dominos_blue,
    borderColor: theme.palette.dominos.dominos_blue,
    transition: "0.2s",
    fontFamily: "BebasNeue-Bold",
    textTransform: "uppercase",
    "&:hover": {
      color: "#ffffff",
      fontSize: 25,
      background: theme.palette.dominos.dominos_blue,
      borderColor: theme.palette.dominos.dominos_blue,
    },
  },

  excel_outlined_button: {
    background: "#fff",
    color: "#1d6f42",
    borderColor: "#1d6f42",
    transition: "1s",
    fontFamily: "BebasNeue-Bold",
    fontWeight: 900,
    letterSpacing: "1px",
    fontSize: "18px",
    textTransform: "uppercase",
    "&:hover": {
      background: "#1d6f42",
      borderColor: "#1d6f42",
      color: "#fff",
      transition: "1s",
      boxShadow:
        "4px 4px 3px -1px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
    },
  },

  pdf_outlined_button: {
    background: "#fff",
    color: "#CD2A29",
    borderColor: "#CD2A29",
    transition: "1s",
    fontFamily: "BebasNeue-Bold",
    fontWeight: 900,
    letterSpacing: "1px",
    fontSize: "18px",
    textTransform: "uppercase",
    "&:hover": {
      background: "#CD2A29",
      borderColor: "#CD2A29",
      color: "#fff",
      transition: "1s",
      boxShadow:
        "4px 4px 3px -1px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
    },
  },

  red_outlined_button: {
    background: theme.palette.dominos.dominos_white,
    color: theme.palette.dominos.dominos_red,
    borderColor: theme.palette.dominos.dominos_red,
    transition: "1s",
    fontFamily: "BebasNeue-Bold",
    fontWeight: 900,
    letterSpacing: "1px",
    fontSize: "18px",
    textTransform: "uppercase",
    "&:hover": {
      background: theme.palette.dominos.dominos_red,
      color: theme.palette.dominos.dominos_white,
      borderColor: theme.palette.dominos.dominos_red,
      transition: "1s",
      boxShadow:
        "4px 4px 3px -1px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
    },
  },

  green_outlined_button: {
    background: theme.palette.dominos.dominos_white,
    color: "#00c853",
    borderColor: "#00c853",
    transition: "1s",
    fontFamily: "BebasNeue-Bold",
    fontWeight: 900,
    letterSpacing: "1px",
    fontSize: "18px",
    textTransform: "uppercase",
    "&:hover": {
      background: "#00c853",
      color: theme.palette.dominos.dominos_white,
      borderColor: "#00c853",
      transition: "1s",
      boxShadow:
        "4px 4px 3px -1px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
    },
  },

  outlined_button: {
    background: theme.palette.dominos.dominos_white,
    color: theme.palette.dominos.dominos_blue,
    borderColor: theme.palette.dominos.dominos_blue,
    transition: "1s",
    fontFamily: "BebasNeue-Bold",
    fontWeight: 900,
    letterSpacing: "1px",
    fontSize: "18px",
    textTransform: "uppercase",
    "&:hover": {
      background: theme.palette.dominos.dominos_blue,
      color: theme.palette.dominos.dominos_white,
      transition: "1s",
      boxShadow:
        "4px 4px 3px -1px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
    },
  },

  disabled_button: {
    background: theme.palette.dominos.grey1,
    color: theme.palette.dominos.grey3,
    borderColor: theme.palette.dominos.grey1,
    transition: "0.2s",
    fontFamily: "BebasNeue-Bold",
    fontSize: 18,
    textTransform: "uppercase",
  },

  modal_background: {
    backgroundColor: theme.palette.dominos.dominos_blue,
    background: theme.palette.dominos.dominos_blue,
    padding: "10px 20px",
    textTransform: "uppercase"
  },

  modal_title: {
    fontSize: 22,
    fontWeight: "normal",
    lineHeight: "normal",
    color: default_label_colors.color_h,
    letterSpacing: "0.015em",
    fontFamily: "BebasNeue-Bold",
  },

  card_label_style: {
    fontSize: 16,
    color: "gray",
    fontFamily: "Roboto-Medium",
  },

  card_value_style: {
    fontSize: 16,
    color: theme.palette.dominos.black,
    fontFamily: "Roboto-Medium",
  },

  profile_name: {
    fontSize: 20,
    color: theme.palette.dominos.black,
    fontFamily: "Roboto-Bold",
    letterSpacing: 1.5,
  },

  accordion_head_container: {
    backgroundColor: `${theme.palette.dominos.dominos_red} !important`,
    background: `${theme.palette.dominos.dominos_red} !important`,
    width: "100%",
    paddingLeft: 15,
    paddingRight: 15,
    borderRadius: "3px 3px 0px 0px ",
    minHeight: `38px !important`,
    height: `38px !important`,
  },

  accordion_heading: {
    fontSize: 20,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "0.015em",
    color: theme.palette.dominos.black,
    fontFamily: "Roboto-Medium",
  },

  accordion_icons: {
    fontSize: 20,
    color: theme.palette.dominos.grey3,
  },

  accordion_container: {
    border: `1px solid ${theme.palette.dominos.dominos_red}`,
  },

  accordion_detail_padding: {
    padding: "24px 32px 30px",
  },

  toggle_sections: {
    color: theme.palette.dominos.dominos_blue,
    fontSize: 16,
    paddingLeft: 15,
    fontFamily: "Roboto-Regular",
    cursor: "pointer",
  },

  view_image_text: {
    display: "flex",
    alignItems: "center",
    padding: 10,
    fontFamily: "RobotoCondensed-Regular",
    color: theme.palette.dominos.dominos_blue,
  },

  dialog_footer_info: {
    fontSize: 14,
    fontFamily: "RobotoCondensed-Regular",
    color: theme.palette.dominos.grey3,
    width: "max-content",
  },

  dialog_description: {
    fontSize: 16,
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: theme.palette.dominos.grey3,
    fontFamily: "Roboto-Medium",
  },

  dialog_description_2: {
    fontSize: 16,
    color: theme.palette.dominos.dominos_blue,
    fontFamily: "RobotoCondensed-Regular",
  },

  radio_label: {
    fontSize: 16,
    fontFamily: "Roboto-Medium",
    color: theme.palette.dominos.dominos_blue,
  },

  unselect_radio_label: {
    fontSize: 16,
    fontFamily: "Roboto-Medium",
    color: theme.palette.dominos.grey3,
  },

  form_container: {
    background: "#ffffff",
    padding: 20,
    border: `2px solid ${theme.palette.dominos.dominos_white}`,
    [theme.breakpoints.down("sm")]: {},
  },

  form_container_without_padding: {
    background: "#ffffff",
    [theme.breakpoints.down("sm")]: {},
  },

  setting_icons: {
    color: theme.palette.dominos.dominos_blue,
    height: 60,
    width: "100%",
  },

  setting_container: {
    background: "#ffffff",
    margin: 30,
    padding: 20,
    border: `2px solid ${theme.palette.dominos.dominos_white}`,
    borderRadius: 5,
    [theme.breakpoints.down("sm")]: {},
  },

  setting_heading: {
    fontSize: 18,
    fontFamily: "Roboto-Medium",
  },

  setting_description: {
    fontSize: 15,
    fontFamily: "Roboto-Regular",
    color: theme.palette.dominos.grey3,
  },

  setting_hover: {
    transition: "0.5s",
    padding: 10,
    borderRadius: 10,
    "&:hover": {
      background: theme.palette.dominos.dominos_red,
      transition: "0.5s",
    },
  },

  switch_label: {
    fontSize: 16,
    fontFamily: "Roboto-Regular",
    color: theme.palette.dominos.dominos_blue,
  },

  rate_dialog_label: {
    fontSize: 16,
    fontFamily: "Roboto-Medium",
    color: theme.palette.dominos.grey3,
  },

  responsive_width: {
    width: "30%",
    [theme.breakpoints.down("xl")]: {
      width: "50%",
    },
    [theme.breakpoints.down("lg")]: {
      width: "50%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },

  commission_label: {
    fontSize: 16,
    color: theme.palette.dominos.grey3,
    fontFamily: "RobotoCondensed-Medium",
  },

  dashboard_card_head: {
    fontSize: 34,
    color: theme.palette.dominos.dominos_blue,
    fontFamily: "BebasNeue-Bold",
  },

  dashboard_card_title: {
    fontSize: 18,
    color: theme.palette.dominos.dominos_blue,
    fontFamily: "Roboto-Medium",
  },

  dashboard_card_container: {
    padding: 10,
    border: `1px solid ${theme.palette.dominos.dominos_blue}`,
    borderRadius: 5,
    position: "relative",
    boxShadow: `0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)`,
  },

  active_tab_button: {
    background: theme.palette.dominos.dominos_white,
    fontFamily: "BebasNeue-Bold",
    fontSize: 18,
    letterSpacing: 1,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
  },

  inactive_tab_button: {
    background: theme.palette.dominos.dominos_blue,
    fontFamily: "BebasNeue-Bold",
    fontSize: 18,
    color: "#ffffff !important",
    letterSpacing: 1,
  },

  typography_heading: {
    fontFamily: "BebasNeue-Bold",
    fontWeight: 400,
    fontSize: 24,
    lineHeight: 1.334,
    letterSpacing: 1,
    textTransform: "uppercase",
  },

  typography_sales_heading: {
    fontFamily: "BebasNeue-Bold",
    fontWeight: 400,
    fontSize: 28,
    lineHeight: 1.334,
    letterSpacing: 1,
    textTransform: "uppercase",
  },

  typography_blue_heading: {
    fontFamily: "BebasNeue-Bold",
    fontWeight: 400,
    fontSize: 24,
    lineHeight: 1.334,
    letterSpacing: 1,
    textTransform: "uppercase",
    color: theme.palette.dominos.dominos_blue,
  },

  typography_red_heading: {
    fontFamily: "BebasNeue-Bold",
    fontWeight: 400,
    fontSize: 20,
    lineHeight: 1.334,
    letterSpacing: 1,
    textTransform: "uppercase",
    color: theme.palette.dominos.dominos_red,
  },

  typography_login_heading: {
    fontFamily: "BebasNeue-Bold",
    fontWeight: 400,
    fontSize: 28,
    lineHeight: 1.334,
    letterSpacing: 1,
    textTransform: "uppercase",
    color: theme.palette.dominos.dominos_white,
  },

  typography_employee_time_clock_heading: {
    fontFamily: "BebasNeue-Bold",
    fontWeight: 400,
    fontSize: 24,
    lineHeight: 1.334,
    letterSpacing: 1,
    textTransform: "uppercase",
    color: theme.palette.dominos.dominos_white,
  },

  typography_caption: {
    fontFamily: "Roboto-Condensed-Regular",
    fontWeight: 600,
    fontSize: 13,
    lineHeight: 1.334,
    letterSpacing: 1,
    marginLeft: 1,
    marginTop: 1,
    color: theme.palette.dominos.dominos_white,
    cursor: "pointer",
    "&:hover": {
      color: theme.palette.dominos.dominos_red,
    },
  },

  disabled_typography_caption: {
    fontFamily: "Roboto-Condensed-Regular",
    fontWeight: 600,
    fontSize: 13,
    lineHeight: 1.334,
    letterSpacing: 1,
    marginLeft: 1,
    marginTop: 1,
    color: theme.palette.dominos.dominos_white,
    cursor: "pointer",
  },

  typography_sales_subtitle: {
    fontFamily: "Roboto-Condensed-Regular",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: 1.334,
    letterSpacing: 1,
    marginLeft: 1,
    marginTop: 1,
    color: theme.palette.dominos.black,
    cursor: "pointer",
    "&:hover": {
      color: theme.palette.dominos.dominos_red,
    },
  },

  app_bar: {
    backgroundColor: theme.palette.dominos.dominos_blue,
    boxShadow: "none",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
  },

  expansion_panel_summary: {
    backgroundColor: "#0078ac",
    fontFamily: "BebasNeue-Bold",
    textTransform: "uppercase",
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5,
  },

  expand_more_icon: {
    color: "white",
  },

  link_error: {
    fontWeight: "bold",
    color: "#000000",
    fontSize: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "BebasNeue-Book",
    textTransform: "uppercase",
  },

  red_app_bar: {
    backgroundColor: theme.palette.dominos.dominos_red,
    boxShadow: "none",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },

  red_active_tab_button: {
    background: theme.palette.dominos.dominos_white,
    color: theme.palette.dominos.dominos_red,
    fontFamily: "BebasNeue-Bold",
    fontSize: 18,
    letterSpacing: 1,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },

  red_inactive_tab_button: {
    background: theme.palette.dominos.dominos_red,
    fontFamily: "BebasNeue-Bold",
    fontSize: 18,
    color: "#ffffff !important",
    letterSpacing: 1,
  },

  sticky: {
    position: "sticky",
    left: 0,
  },
}));

export default useStyles;
